import React, { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { useLang } from "../i18n";
import Seo from "../components/Seo";
import { GoldButton } from "../components/motion";

export default function PaymentStatus() {
  const { t, lang } = useLang();
  const [params] = useSearchParams();
  const bookingId = params.get("booking_id");
  const [status, setStatus] = useState("checking");
  const attempts = useRef(0);

  useEffect(() => {
    if (!bookingId) return setStatus("failed");
    let timer;
    const poll = async () => {
      attempts.current += 1;
      try {
        const r = await api.get(`/payments/${bookingId}/status`);
        const s = r.data.payment_status || r.data.status;
        if (["paid", "complete", "completed", "succeeded"].includes(s)) return setStatus("success");
        if (["failed", "expired", "canceled", "cancelled"].includes(s)) return setStatus("failed");
      } catch {
        // keep polling
      }
      if (attempts.current >= 12) return setStatus("pending");
      timer = setTimeout(poll, 2500);
    };
    poll();
    return () => clearTimeout(timer);
  }, [bookingId]);

  const messages = { checking: t("pay.checking"), success: t("pay.success"), failed: t("pay.failed"), pending: t("pay.pending") };
  const icons = { checking: "…", success: "✓", failed: "✕", pending: "…" };

  return (
    <div className="pt-[72px] min-h-[80vh] flex items-center justify-center px-4">
      <Seo title="Payment — Chef à Domicile" description="" />
      <div className="text-center max-w-md" data-testid={`payment-status-${status}`}>
        <p className={`font-serif text-6xl mb-6 ${status === "success" ? "text-gold" : status === "failed" ? "text-red-400" : "text-neutral-500 animate-pulse"}`}>
          {icons[status]}
        </p>
        <p className="text-ivory text-lg leading-relaxed mb-10">{messages[status]}</p>
        <Link to={`/${lang}/account`}><GoldButton data-testid="payment-back-account-btn">{t("pay.backAccount")}</GoldButton></Link>
      </div>
    </div>
  );
}
